import React from "react";
import { Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faUsers, faClock, faCheck, faXmark, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import ShiftBreakdown from "./ShiftBreakdown";

interface IShiftCount {
    shiftId: string;
    noOfStudents: number;
    shiftName: string;
}

interface ICenter {
    center: string;
    shift_count: IShiftCount[];
}

interface Props {
    center: ICenter;
    index: number;
    totalStudents: number;
    isExpanded: boolean;
    toggleRow: (id: string) => void;
    hasInvigilators?: boolean;
    invigilator?: any;
}

export default function CenterRow({ center, index, totalStudents, isExpanded, toggleRow, hasInvigilators = false, invigilator }: Props) {
    return (
        <>
            <tr
                style={{
                    cursor: "pointer"
                }}
                onClick={() => toggleRow(center.center)}
            >
                <td className="px-4 py-3 align-middle">
                    <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} className="text-muted" />
                </td>
                <td className="px-4 py-3 align-middle">
                    <div className="d-flex align-items-center">
                        <FontAwesomeIcon icon={faBuilding} className="text-primary me-2" />
                        <div>
                            <div className="fw-bold text-dark">{center.center}</div>
                            <small className="text-muted">Center #{index + 1}</small>
                        </div>
                    </div>
                </td>
                <td className="px-4 py-3 align-middle">
                    <Badge bg="primary" className="px-3 py-2">
                        <FontAwesomeIcon icon={faUsers} className="me-2" />
                        {totalStudents.toLocaleString()}
                    </Badge>
                </td>
                <td className="px-4 py-3 align-middle">
                    <div className="d-flex align-items-center">
                        <FontAwesomeIcon icon={faClock} className="text-info me-2" />
                        <span className="fw-semibold">{center.shift_count.length} shifts</span>
                    </div>
                </td>
                <td className="px-4 py-3 align-middle text-center">
                    {hasInvigilators && invigilator ? (
                        <div>
                            <Badge bg="success" className="px-3 py-2 d-inline-flex align-items-center">
                                <FontAwesomeIcon icon={faCheck} className="me-2" />
                                Assigned
                            </Badge>
                            <div className="small text-muted mt-1">{invigilator.userName || invigilator.centerInvId}</div>
                        </div>
                    ) : (
                        <Badge bg="danger" className="px-3 py-2">
                            <FontAwesomeIcon icon={faXmark} className="me-2" />
                            Pending
                        </Badge>
                    )}
                </td>
            </tr>

            {isExpanded && (
                <tr>
                    <td colSpan={5} className="p-0 bg-light">
                        <div className="p-3">
                            <div className="row g-3 align-items-stretch">

                                <div className="col-lg-8 col-md-7">
                                    <div className="card h-100 shadow-sm">
                                        <div className="card-body">
                                            <h6 className="card-title text-secondary mb-3">
                                                Shift Breakdown
                                            </h6>
                                            <ShiftBreakdown shifts={center.shift_count} />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-5">
                                    <div className="card h-100 shadow-sm border-start border-4 border-primary">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h6 className="mb-0 text-primary">Invigilator</h6>

                                                {hasInvigilators && invigilator && (
                                                    <span
                                                        className={`badge ${invigilator.isAllowed
                                                                ? 'bg-success'
                                                                : 'bg-danger'
                                                            }`}
                                                    >
                                                        {invigilator.isAllowed ? 'Allowed' : 'Not Allowed'}
                                                    </span>
                                                )}
                                            </div>

                                            {hasInvigilators && invigilator ? (
                                                <>
                                                    <div className="fw-semibold">
                                                        {invigilator.userName || '—'}
                                                    </div>

                                                    <div className="text-muted small mb-2">
                                                        ID: {invigilator.centerInvId}
                                                    </div>

                                                    <hr className="my-2" />

                                                    <div className="small text-muted">
                                                        Created on
                                                    </div>
                                                    <div className="small">
                                                        {new Date(invigilator.createdAt).toLocaleString()}
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="text-muted small fst-italic">
                                                    No invigilator assigned for this center.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </td>
                </tr>
            )}
        </>
    );
}